"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTargetHeldBackIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CardTargetHeldBackIndicator = exports.CardTargetHeldBackIndicator = function CardTargetHeldBackIndicator(_ref) {
  var heldBackReason = _ref.heldBackReason;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex items-center gap-1 text-[11px] font-medium text-[#92400E]",
    role: "status",
    "data-sentry-component": "CardTargetHeldBackIndicator",
    "data-sentry-source-file": "CardTargetHeldBackIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 13,
      height: 13,
      className: "flex-shrink-0",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "CardTargetHeldBackIndicator.tsx"
    }), heldBackReason]
  });
};